var map = {
	"./de.json": [
		1708,
		42
	],
	"./en-AU.json": [
		1709,
		43
	],
	"./en-GB.json": [
		1710,
		44
	],
	"./en-HK.json": [
		1711,
		45
	],
	"./en-SG.json": [
		1712,
		46
	],
	"./en-us.json": [
		1713,
		47
	],
	"./fr.json": [
		1714,
		48
	],
	"./global.json": [
		1715,
		49
	],
	"./it.json": [
		1716,
		50
	],
	"./zh-Hant.json": [
		1717,
		51
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1705;
module.exports = webpackAsyncContext;